import React from 'react';
import MaskedTextInput from 'react-text-mask';

export default ({ name, onChange }) => {
  return (
    <MaskedTextInput
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      className="mdc-text-field__input hrbr-phone-number-control"
      name={name}
      placeholder="Enter a phone number"
      onChange={onChange}
      guide={false}
    />
  );
};
